import { Options } from '../options.interface';
import { SUBSCRIPTION_API_CONFIG } from './subscription-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Campaign, Folder, LocaleEnum } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class SubscriptionWebservice {
  readonly #http = inject(HttpClient);
  readonly #subscriptionApiConfig = inject(SUBSCRIPTION_API_CONFIG);

  readonly #baseUrl = this.#subscriptionApiConfig.baseUrl;
  readonly #locale = this.#subscriptionApiConfig.locale;

  getFolders(options?: Options): Observable<Record<string, Folder[]>> {
    return this.#http.get<Record<string, Folder[]>>(`${this.#baseUrl}/v1/folders-for-account`, options);
  }

  getCampaigns(appId: string, options?: Options): Observable<Record<string, Campaign[]>> {
    return this.#http.get<Record<string, Campaign[]>>(
      `${this.#baseUrl}/v1/campaigns-by-app/${appId}/${this.#locale || LocaleEnum.fr_FR}`,
      options
    );
  }

  getSingleFolder(id: string, options: Options): Observable<Folder> {
    return this.#http.get<Folder>(`${this.#baseUrl}/v1/folder/${id}`, options);
  }

  getFoldersFor(parentId: string, options: Options): Observable<Folder[]> {
    return this.#http.get<Folder[]>(`${this.#baseUrl}/folders-by-parent-id/${parentId}`, options);
  }
}
